import { call, put, takeEvery, all } from 'redux-saga/effects';
import getConfig from 'next/config';
import * as newayApi from '../../api/neway';
import * as calculationTypes from '../constants/calculations';
import { FILE_KREDITDATA_SAVE_REQUEST } from '../constants/file';

function* fetchAndSaveKreditdata({ payload }) {
    const { publicRuntimeConfig:{ uniify } } = getConfig();
    try {
        yield put({
            type: 'FILE_KREDITDATA_SAVE_REQUESTED',
        });
        const { content, fileType } = yield call(newayApi.fetchKreditdata, { id: payload.id });
        yield put({
            type: FILE_KREDITDATA_SAVE_REQUEST,
            payload: { id: payload.id, content, fileType },
        });
        if(content?.sourceResponse?.Status === 'IN_PROGRESS' || content?.sourceResponse?.Status === 'CREATED'){
            const templateIdKey = 'pensionsInfoTemplateId';
            const kreditDataUrl = `https://app.kreditdata.dk/consent/${uniify.teamId}/${uniify[templateIdKey]}?cc=${payload.id}`;
            window.location.assign(kreditDataUrl);
        }
        if(content?.sourceResponse?.Status === 'ABANDONED'){
            const customerId = yield call(newayApi.inviteUserToKreditdata, { flow: 'pensionsInfo' });
            const templateIdKey = 'pensionsInfoTemplateId';
            const kreditDataUrl = `https://app.kreditdata.dk/consent/${uniify.teamId}/${uniify[templateIdKey]}?cc=${customerId}`;
            window.location.assign(kreditDataUrl);
        }
        if(fileType === 'PensionsInfoFile'){
            yield put({
                type: 'PI_SCRAPE_SUCCESS',
                payload: {
                    ...content,
                    timeStamp: new Date().toString(),
                    type: 'pensionsInfo',
                },
            });
        }

    } catch (error) {
        yield put({ type: 'KREDITDATA_FETCH_FAIL', payload: error });
    }
}
function* fetchAndSavePartnerKreditdata({ payload }) {
    try {
        yield call(newayApi.fetchPartnerKreditdata, { ...payload });
        yield put({
            type: 'KREDITDATA_PARTNER_FETCH_SUCCESS',
        });
    } catch (error) {
        yield put({ type: 'KREDITDATA_FETCH_FAIL', payload: error });
    }
}
function* requestPensionAnalysis() {
    yield put({
        type: calculationTypes.PENSION_ANALYSIS_CALCULATION_REQUEST,
    });
}
export default function* fetchSaga() {
    yield all([takeEvery('KREDITDATA_FETCH_REQUEST', fetchAndSaveKreditdata), takeEvery('KREDITDATA_FETCH_PARTNER_REQUEST', fetchAndSavePartnerKreditdata), takeEvery('KREDIT_DATA_PENSION_PDF_SAVE_SUCCESS', requestPensionAnalysis)]);
}
